export default __webpack_public_path__ + "static/media/3s.bf6952e2.png";